import { BannerType } from '@generated/graphql';
import type { SvgIconComponent } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import NewReleases from '@mui/icons-material/NewReleases';
import WarningIcon from '@mui/icons-material/Warning';
import type { PaletteToken } from 'hephaestus/core';

export type BannerTypeOption = {
  key: BannerType;
  icon: SvgIconComponent;
  backgroundColor: keyof PaletteToken;
  supportColor: keyof PaletteToken;
};

export const BANNER_TYPE_OPTIONS: BannerTypeOption[] = [
  {
    key: BannerType.Info,
    icon: NewReleases,
    backgroundColor: 'primary20',
    supportColor: 'primary50',
  },
  {
    key: BannerType.Success,
    icon: CheckCircleIcon,
    backgroundColor: 'positive40',
    supportColor: 'positive60',
  },
  {
    key: BannerType.Warning,
    icon: WarningIcon,
    backgroundColor: 'warning40',
    supportColor: 'warning70',
  },
  {
    key: BannerType.Urgent,
    icon: ErrorIcon,
    backgroundColor: 'negative40',
    supportColor: 'negative70',
  },
];

const BANNER_TYPE_ORDER: Record<BannerType, number> = {
  [BannerType.Urgent]: 0,
  [BannerType.Warning]: 1,
  [BannerType.Success]: 2,
  [BannerType.Info]: 3,
};

type SortableBannerInteraction = {
  alertBanner: {
    bannerType?: BannerType | null;
    createdAt: string;
  };
};

export const sortBannerInteractionsByType = <
  T extends SortableBannerInteraction,
>(
  bannerInteractions: T[],
) =>
  [...bannerInteractions].sort((a, b) => {
    const orderA = a.alertBanner.bannerType
      ? BANNER_TYPE_ORDER[a.alertBanner.bannerType]
      : 4;
    const orderB = b.alertBanner.bannerType
      ? BANNER_TYPE_ORDER[b.alertBanner.bannerType]
      : 4;

    if (orderA !== orderB) return orderA - orderB;

    return a.alertBanner.createdAt.localeCompare(b.alertBanner.createdAt);
  });
